import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, of, mergeMap, map } from 'rxjs';
import { UserManagerService } from '../services/userManager.service';

@Injectable()
export class CustomMsalInterceptor implements HttpInterceptor {
  private userLoaded = false;

  constructor(private userManagerService: UserManagerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip user loading for certain endpoints to avoid recursion
    const isUserApiCall = req.url.toLowerCase().includes('api/user') || 
                         req.url.toLowerCase().includes('adduserifneeded');
    
    // If user is already loaded or this is a user API call, proceed with the request
    if (this.userLoaded || isUserApiCall) {
      return next.handle(req);
    }

    // Otherwise ensure user is loaded before proceeding with the request
    return this.userManagerService.getCurrentUser().pipe(
      map(user => {
        if (user) {
          this.userLoaded = true;
        }
        return user;
      }),
      mergeMap(() => next.handle(req))
    );
  }
}